import { Tooltip } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import { useNavigate } from "react-router-dom";

import { TableHelper } from "../../../util/TableHelper";
import styles from "../../UserManagement/WebUser/WebUserList/index.module.less";
import { RouteConstants } from "../../../constants/ApplicationConstants/RouteConstants";

import type FixMeLater from "../../../shared/types/fixMeLater.type";

const ManualStorageRetrievalRequestTable = () => {
  const navigate = useNavigate();

  const dummydata = [
    {
      sr_no: 1,
      customer_name: "c1",
      car_number: "z111",
      car_type: "SUV"
    }
  ];

  const renderText = (text: FixMeLater) => {
    return <div className="wordWrapWordBreak">{TableHelper.getValue(text)}</div>;
  };

  const columns: ColumnsType<FixMeLater> = [
    {
      align: "right",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("id")
      },
      width: "5%"
    },
    {
      align: "left",
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      }
    },
    {
      align: "left",
      title: "Car Number ",
      dataIndex: "car_number",
      key: "car_number",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("car_number")
      }
    },
    {
      align: "left",
      title: "Car Type",
      dataIndex: "car_type",
      key: "car_type",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("car_type")
      }
    },
    {
      align: "left",
      title: "Parking Spot Number",
      dataIndex: "customer_name",
      key: "customer_name",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      }
    },
    {
      align: "left",
      title: "Queue Number",
      dataIndex: "customer_name",
      key: "customer_name",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      }
    },
    {
      align: "left",
      title: "Pickup Location",
      dataIndex: "customer_name",
      key: "customer_name",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      }
    },
    {
      align: "left",
      title: "Date and Time",
      dataIndex: "customer_name",
      key: "customer_name",
      render: renderText,
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      }
    },
    {
      align: "left",
      title: "Action",
      render: (text, record) => (
        <div className={`${styles["actionAllDevice"]}`}>
          <Tooltip title="View ">
            <i onClick={handleView} className={`icon icon-view ${styles["user-list__table--action-col-icon"]} `} />
          </Tooltip>

          <Tooltip title="Edit">{!record?.is_active ? <i onClick={handleEdit} className={`gx-link icon icon-edit ${styles["action-icon"]} `} /> : <i className={`icon icon-edit icon-disabled ${styles["action-icon"]} `} />}</Tooltip>
        </div>
      )
    }
  ];
  const handleView = () => {
    navigate(`${RouteConstants.BOOKING_RETRIEVAL_REQUEST_PAGE}/${RouteConstants.USER_FORM_ADD_PAGE}`);
  };
  const handleEdit = () => {
    navigate(`${RouteConstants.BOOKING_RETRIEVAL_REQUEST_PAGE}/${RouteConstants.USER_FORM_ADD_PAGE}`);
  };

  return (
    <>
      <Table className="gx-table-responsive" columns={columns} dataSource={dummydata} bordered rowKey={(record) => record.sr_no} />
    </>
  );
};
export default ManualStorageRetrievalRequestTable;
